import QuestionnaireFlow from "../pages/OfferQuestions/QuestionnaireFlow.vue";
import App from "@/App.vue";
import AdminLayout from "@/layout/AdminLayout.vue";
import AuthLayout from "@/layout/AuthLayout.vue";

// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ "@/pages/Dashboard.vue");
const Doctor = () => import(/* webpackChunkName: "dashboard" */"@/pages/Doctor.vue");
const Doctors = () => import(/* webpackChunkName: "common" */ "@/pages/Doctors.vue");
const Clinics = () => import(/* webpackChunkName: "common" */ "@/pages/Clinics.vue");
const TopPlacements = () => import(/* webpackChunkName: "top-placements" */ "@/pages/TopPlacements.vue");
const PartnerVideos = () => import(/* webpackChunkName: "partner-videos" */ "@/pages/PartnerVideos.vue");
const Clinic = () => import(/* webpackChunkName: "common" */ "@/pages/Clinic.vue");
const ClinicEntityTexts = () => import(/* webpackChunkName: "common" */ "@/pages/ClinicEntityTexts.vue");
const Operations = () => import(/* webpackChunkName: "common" */ "@/pages/Operations.vue");
const Operation = () => import(/* webpackChunkName: "common" */ "@/pages/Operation.vue");
const Illnesses = () => import(/* webpackChunkName: "common" */ "@/pages/Illnesses.vue");
const Illness = () => import(/* webpackChunkName: "common" */ "@/pages/Illness.vue");
const Diagnostics = () => import(/* webpackChunkName: "common" */ "@/pages/Diagnostics.vue");
const Diagnostic = () => import(/* webpackChunkName: "common" */ "@/pages/Diagnostic.vue");
const IllnessKinds = () => import(/* webpackChunkName: "common" */ "@/pages/Illness-kinds.vue");
const IllnessKind = () => import(/* webpackChunkName: "common" */ "@/pages/Illness-kind.vue");
const Cities = () => import(/* webpackChunkName: "common" */ "@/pages/Cities.vue");
const City = () => import(/* webpackChunkName: "common" */ "@/pages/City.vue");
const Countries = () => import(/* webpackChunkName: "common" */ "@/pages/Countries.vue");
const Country = () => import(/* webpackChunkName: "common" */ "@/pages/Country.vue");
const Reviews = () => import(/* webpackChunkName: "common" */ "@/pages/Reviews.vue");
const Review = () => import(/* webpackChunkName: "common" */ "@/pages/Review.vue");
const UnlinkRequests = () => import(/* webpackChunkName: "common" */ "@/pages/UnlinkRequests.vue");
const HelpCenterList = () => import(/* webpackChunkName: "common" */ "@/pages/HelpCenter/HelpCenterList.vue");
const HelpCenterEdit = () => import(/* webpackChunkName: "common" */ "@/pages/HelpCenter/HelpCenterEdit.vue");
const HelpCenterCreate = () => import(/* webpackChunkName: "common" */ "@/pages/HelpCenter/HelpCenterCreate.vue");
const HelpCenterCategoriesList = () => import(/* webpackChunkName: "common" */ "@/pages/HelpCenterCategories/HelpCenterCategoriesList.vue");
const HelpCenterCategoriesCreate = () => import(/* webpackChunkName: "common" */ "@/pages/HelpCenterCategories/HelpCenterCategoriesCreate.vue");
const HelpCenterCategoriesEdit = () => import(/* webpackChunkName: "common" */ "@/pages/HelpCenterCategories/HelpCenterCategoriesEdit.vue");
const ClinicParser = () => import(/* webpackChunkName: "common" */ "@/pages/ClinicParser.vue");
const OffersList = () => import(/* webpackChunkName: "offers" */ "@/pages/Offers/OffersList.vue");
const OffersCreate = () => import(/* webpackChunkName: "offers" */ "@/pages/Offers/OffersCreate.vue");
const OffersEdit = () => import(/* webpackChunkName: "offers" */ "@/pages/Offers/OffersEdit.vue");
const AgencyEdit = () => import(/* webpackChunkName: "agencies" */ "@/pages/AgencyEdit.vue");
const Agencies = () => import(/* webpackChunkName: "common" */ "@/pages/Agencies.vue");
const AgencyCommission = () => import(/* webpackChunkName: "common" */ "@/pages/AgencyCommission.vue");
const Agents = () => import(/* webpackChunkName: "common" */ "@/pages/Agents.vue");
const AITexts = () => import(/* webpackChunkName: "common" */ "@/pages/AITexts.vue");
const CustomPagesList = () => import(/* webpackChunkName: "custom-pages" */ "@/pages/CustomPages/CustomPagesList.vue");
const MediaImagesList = () => import(/* webpackChunkName: "media-images" */ "@/pages/MediaImages/MediaImagesList.vue");
const ManualSeoList = () => import(/* webpackChunkName: "manual-seo" */ "@/pages/ManualSeo/ManualSeoList.vue");
const EmployeesList = () => import(/* webpackChunkName: "employees" */ "@/pages/Employees/EmployeesList.vue");
const EmployeeEdit = () => import(/* webpackChunkName: "employees" */ "@/pages/Employees/EmployeeEdit.vue");
const CustomPageCreate = () => import(/* webpackChunkName: "custom-pages" */ "@/pages/CustomPages/CustomPageCreate.vue");
const CustomPageEdit = () => import(/* webpackChunkName: "custom-pages" */ "@/pages/CustomPages/CustomPageEdit.vue");
const ArticlesList = () => import(/* webpackChunkName: "articles" */ "@/pages/Articles/ArticlesList.vue");
const ArticleCreate = () => import(/* webpackChunkName: "articles" */ "@/pages/Articles/ArticleCreate.vue");
const ArticleEdit = () => import(/* webpackChunkName: "articles" */ "@/pages/Articles/ArticleEdit.vue");
const SpecialitiesList = () => import(/* webpackChunkName: "common" */ "@/pages/Specialities/SpecialitiesList.vue");
const AccreditationsList = () => import(/* webpackChunkName: "common" */ "@/pages/Accreditations/AccreditationsList.vue");
const AccreditationEdit = () => import(/* webpackChunkName: "common" */ "@/pages/Accreditations/AccreditationEdit.vue");
const ClinicContentModeration = () => import(/* webpackChunkName: "common" */ "@/pages/ClinicContentModeration/ClinicContentModeration.vue");
const OfferServicesList = () => import(/* webpackChunkName: "offer-services" */ "@/pages/OfferServices/OfferServicesList.vue");
const OfferServicesCreate = () => import(/* webpackChunkName: "offer-services" */ "@/pages/OfferServices/OfferServicesCreate.vue");
const OfferServicesEdit = () => import(/* webpackChunkName: "offer-services" */ "@/pages/OfferServices/OfferServicesEdit.vue");
const OfferQuestionsList = () => import(/* webpackChunkName: "offer-questions" */ "@/pages/OfferQuestions/OfferQuestionsList.vue");
const OfferQuestionsCreate = () => import(/* webpackChunkName: "offer-questions" */ "@/pages/OfferQuestions/OfferQuestionsCreate.vue");
const OfferQuestionsEdit = () => import(/* webpackChunkName: "offer-questions" */ "@/pages/OfferQuestions/OfferQuestionsEdit.vue");
const DocsList = () => import(/* webpackChunkName: "static-pages" */ "@/pages/Docs/DocsList.vue");
const DocEdit = () => import(/* webpackChunkName: "static-pages" */ "@/pages/Docs/DocEdit.vue");

const routes = [
  {
    path: "/",
    component: App,
    redirect: { name: 'Dashboard' },
    children: [
      {
        path: 'admin',
        props: true,
        component: AdminLayout,
        redirect: { name: 'Dashboard' },
        children: [
          { path: 'top-placements', name: 'TopPlacements', meta: { title: 'TOP Clinics' }, component: TopPlacements },
          { path: 'partner-videos', name: 'PartnerVideos', meta: { title: 'Відео партнерів' }, component: PartnerVideos },
          {
            path: "dashboard",
            props: true,
            name: "Dashboard",
            meta: { title: 'Dashboard' },
            component: Dashboard,
          },
          {
            path: "doctors",
            props: true,
            name: "Doctors",
            meta: {
              title: 'Doctors',
            },
            component: Doctors
          },
          {
            path: "clinics-parser",
            props: true,
            name: "ClinicParser",
            meta: {
              title: 'Clinic parser',
            },
            component: ClinicParser
          },
          {
            path: "doctor/:doctorId",
            props: true,
            name: "Doctor",
            meta: {
              title: 'Doctor',
              breadcrumbs: [{
                routeName: 'Doctors',
                title: 'Doctors'
              }]
            },
            component: Doctor
          },
          {
            path: "static-pages",
            props: true,
            name: "StaticPages",
            meta: { title: "Static pages" },
            component: DocsList,
          },
          {
            path: "static-pages/:id",
            props: true,
            name: "StaticPage",
            meta: {
              title: "Static page",
              breadcrumbs: [{
                routeName: 'StaticPages',
                title: 'Static pages'
              }]
            },
            component: DocEdit,
          },
          {
            path: "specialities",
            props: true,
            name: "Specialities",
            meta: { title: "Specialities" },
            component: SpecialitiesList,
          },
          {
            path: "accreditations",
            props: true,
            name: "Accreditations",
            meta: { title: "Accreditations" },
            component: AccreditationsList,
          },
          {
            path: "accreditations/:id",
            props: true,
            name: "Accreditation",
            meta: {
              title: "Accreditation",
              breadcrumbs: [{
                routeName: "Accreditations",
                title: "Accreditations",
              }],
            },
            component: AccreditationEdit,
          },
          {
            path: "clinics",
            props: true,
            name: "Clinics",
            meta: {
              title: 'Clinics',
            },
            component: Clinics
          },
          {
            path: "clinic/content-moderation",
            props: true,
            name: "ClinicContentModeration",
            meta: { title: "Clinic Content Moderation" },
            component: ClinicContentModeration,
          },
          {
            path: "clinic/:clinicId",
            props: true,
            name: "Clinic",
            meta: {
              title: 'Clinic',
              breadcrumbs: [{
                routeName: 'Clinics',
                title: 'Clinics'
              }]
            },
            component: Clinic
          },
          {
            path: "/clinic/:clinicId/entity-texts/:entity/:entityId",
            props: true,
            name: "ClinicEntityTexts",
            meta: {
              title: 'Clinic entity texts',
              breadcrumbs: [
                {
                  routeName: 'Clinics',
                  title: 'Clinics'
                },
                {
                  routeName: 'Clinic',
                  title: 'Clinic'
                }
              ]
            },
            component: ClinicEntityTexts
          },
          {
            path: "operations",
            props: true,
            name: "Operations",
            meta: {
              title: 'Operations',
            },
            component: Operations
          },
          {
            path: "operation/:entityId",
            props: true,
            name: "operation",
            meta: {
              title: 'Operation',
              breadcrumbs: [{
                routeName: 'Operations',
                title: 'Operations'
              }]
            },
            component: Operation
          },
          {
            path: "cities",
            props: true,
            name: 'Cities',
            meta: {
              title: 'Cities',
            },
            component: Cities
          },
          {
            path: "city/:entityId",
            props: true,
            name: "city",
            meta: {
              title: 'City',
              breadcrumbs: [{
                routeName: 'Cities',
                title: 'Cities'
              }]
            },
            component: City
          },
          {
            path: "countries",
            props: true,
            name: 'countries',
            meta: {
              title: 'Countries',
            },
            component: Countries
          },
          {
            path: "country/:entityId",
            props: true,
            name: "country",
            meta: {
              title: 'Country',
              breadcrumbs: [{
                routeName: 'countries',
                title: 'Countries'
              }]
            },
            component: Country
          },
          {
            path: "illnesses",
            props: true,
            name: "Illnesses",
            meta: {
              title: 'Illnesses',
            },
            component: Illnesses
          },
          {
            path: "illness/:entityId",
            props: true,
            name: "illness",
            meta: {
              title: 'Illness',
              breadcrumbs: [{
                routeName: 'Illnesses',
                title: 'Illnesses'
              }]
            },
            component: Illness
          },
          {
            path: "illness-kinds",
            props: true,
            name: "illness-kinds",
            meta: {
              title: 'Specialties',
            },
            component: IllnessKinds
          },
          {
            path: "illness-kind/:entityId",
            props: true,
            name: "illness-kind",
            meta: {
              title: 'Specialty',
              breadcrumbs: [{
                routeName: 'illness-kinds',
                title: 'Specialties'
              }]
            },
            component: IllnessKind
          },
          {
            path: "diagnostics",
            props: true,
            name: "Diagnostics",
            meta: {
              title: 'Diagnostics',
            },
            component: Diagnostics
          },
          {
            path: "diagnostic/:entityId",
            props: true,
            name: "diagnostic",
            meta: {
              title: 'Diagnostic',
              breadcrumbs: [{
                routeName: 'Diagnostics',
                title: 'Diagnostics'
              }]
            },
            component: Diagnostic
          },
          {
            path: "reviews",
            props: true,
            name: "Reviews",
            meta: {
              title: 'Reviews',
            },
            component: Reviews
          },
          {
            path: "review/:reviewId",
            props: true,
            name: "Review",
            meta: {
              title: 'Review',
              breadcrumbs: [{
                routeName: 'Reviews',
                title: 'Reviews'
              }]
            },
            component: Review
          },
          {
            path: "unlink-requests",
            props: true,
            name: "Unlink requests",
            meta: {
              title: 'Unlink requests',
            },
            component: UnlinkRequests
          },
          {
            path: "help-center/list",
            props: true,
            name: "list",
            meta: {
              title: 'Help center',
            },
            component: HelpCenterList
          },
          {
            path: "help-center/edit/:id",
            props: true,
            name: "edit",
            meta: {
              title: 'Help center',
            },
            component: HelpCenterEdit
          },
          {
            path: "help-center/create",
            props: true,
            name: "create",
            meta: {
              title: 'Help center',
            },
            component: HelpCenterCreate
          },
          {
            path: "help-center-categories/list",
            props: true,
            name: "categories-list",
            meta: {
              title: 'Help center categories',
            },
            component: HelpCenterCategoriesList
          },
          {
            path: "help-center-categories/create",
            props: true,
            name: "category-create",
            meta: {
              title: 'Help center category',
            },
            component: HelpCenterCategoriesCreate
          },
          {
            path: "help-center-categories/edit/:id",
            props: true,
            name: "category-edit",
            meta: {
              title: 'Help center',
            },
            component: HelpCenterCategoriesEdit
          },
          {
            path: "offers",
            props: true,
            name: "offers-list",
            meta: { title: "Offers" },
            component: OffersList
          },
          {
            path: "offers/create",
            props: true,
            name: "offers-create",
            meta: {
              title: "Create Offer",
              breadcrumbs: [{ routeName: "offers-list", title: "Offers" }]
            },
            component: OffersCreate
          },
          {
            path: "offers/:id",
            props: true,
            name: "offers-edit",
            meta: {
              title: "Edit Offer",
              breadcrumbs: [{ routeName: "offers-list", title: "Offers" }]
            },
            component: OffersEdit
          },
          {
            path: "offer-services",
            props: true,
            name: "offer-services-list",
            meta: { title: "Offer services" },
            component: OfferServicesList,
          },
          {
            path: "offer-services/create",
            props: true,
            name: "offer-services-create",
            meta: {
              title: "Create service",
              breadcrumbs: [{ routeName: "offer-services-list", title: "Offer services" }],
            },
            component: OfferServicesCreate,
          },
          {
            path: "offer-services/:id",
            props: true,
            name: "offer-services-edit",
            meta: {
              title: "Edit service",
              breadcrumbs: [{ routeName: "offer-services-list", title: "Offer services" }],
            },
            component: OfferServicesEdit,
          },
          {
            path: "questionnaire-flows",
            name: "questionnaire-flows",
            component: QuestionnaireFlow,
            meta: { title: "Questionnaire flows" },
          },
          {
            path: "offer-questions",
            props: true,
            name: "offer-questions-list",
            meta: { title: "Offer questions" },
            component: OfferQuestionsList,
          },
          {
            path: "offer-questions/create",
            props: true,
            name: "offer-questions-create",
            meta: {
              title: "Create question",
              breadcrumbs: [{ routeName: "offer-questions-list", title: "Offer questions" }],
            },
            component: OfferQuestionsCreate,
          },
          {
            path: "offer-questions/:id",
            props: true,
            name: "offer-questions-edit",
            meta: {
              title: "Edit question",
              breadcrumbs: [{ routeName: "offer-questions-list", title: "Offer questions" }],
            },
            component: OfferQuestionsEdit,
          },
          {
            path: "custom-pages",
            props: true,
            name: "custom-pages-list",
            meta: { title: "Custom pages" },
            component: CustomPagesList,
          },
          {
            path: "media-images",
            props: true,
            name: "media-images-list",
            meta: { title: "Image storage" },
            component: MediaImagesList,
          },
          {
            path: "manual-seo",
            props: true,
            name: "manual-seo-list",
            meta: { title: "SEO by URLs" },
            component: ManualSeoList,
          },
          {
            path: "employees",
            props: true,
            name: "employees-list",
            meta: { title: "Employees" },
            component: EmployeesList,
          },
          {
            path: "employees/create",
            name: "employees-create",
            meta: { title: "New employee", breadcrumbs: [{ routeName: "employees-list", title: "Employees" }] },
            component: EmployeeEdit,
          },
          {
            path: "employees/:id(\\d+)",
            props: true,
            name: "employees-edit",
            meta: { title: "Employee", breadcrumbs: [{ routeName: "employees-list", title: "Employees" }] },
            component: EmployeeEdit,
          },
          {
            path: "custom-pages/create",
            props: true,
            name: "custom-pages-create",
            meta: {
              title: "Create custom page",
              breadcrumbs: [{ routeName: "custom-pages-list", title: "Custom pages" }],
            },
            component: CustomPageCreate,
          },
          {
            path: "custom-pages/edit",
            props: true,
            name: "custom-pages-edit",
            meta: {
              title: "Edit custom page",
              breadcrumbs: [{ routeName: "custom-pages-list", title: "Custom pages" }],
            },
            component: CustomPageEdit,
          },
          {
            path: "articles",
            props: true,
            name: "articles-list",
            meta: { title: "Articles" },
            component: ArticlesList,
          },
          {
            path: "articles/create",
            props: true,
            name: "articles-create",
            meta: {
              title: "Create Article",
              breadcrumbs: [{ routeName: "articles-list", title: "Articles" }],
            },
            component: ArticleCreate,
          },
          {
            path: "articles/:id",
            props: true,
            name: "articles-edit",
            meta: {
              title: "Edit Article",
              breadcrumbs: [{ routeName: "articles-list", title: "Articles" }],
            },
            component: ArticleEdit,
          },
          {
            path: "agencies/:id(\\d+)",
            props: true,
            name: "AgencyEdit",
            meta: { title: "Edit partner", breadcrumbs: [{ routeName: "Agencies", title: "Partners" }] },
            component: AgencyEdit,
          },
          {
            path: "agencies",
            props: true,
            name: "Agencies",
            meta: { title: 'Partners' },
            component: Agencies,
          },
          {
            path: "agencies/:agencyId/commission",
            props: true,
            name: "AgencyCommission",
            meta: {
              title: 'Commission',
              breadcrumbs: [{ routeName: "Agencies", title: "Partners" }],
            },
            component: AgencyCommission,
          },
          {
            path: "bot/agents",
            props: true,
            name: "Agents",
            meta: {
              title: 'Agents',
            },
            component: Agents
          },
          {
            path: "ai-texts",
            props: true,
            name: "AITexts",
            meta: {
              title: 'AITexts',
            },
            component: AITexts
          },
        ]
      },
      {
        path: 'auth',
        props: true,
        component: AuthLayout,
        redirect: { name: 'Login' },
        children: [
          {
            path: '/auth/login',
            name: 'Login',
            props: true,
            meta: {
              title: 'Login',
            },
            component: () => import('@/pages/Login.vue'),
          },
        ]
      },
    ]
  },
  { path: '*',
    redirect: { name: 'Doctors' },
  },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
